import axios from "axios";
import { Message } from "element-ui";
const timeout = 30000;
let urlSuffix = "-dev";
const fileUrl = `/cim6d-file${urlSuffix}`;
const service = create("");
const file = create(fileUrl); // 智慧施工2.0工作台
service.file = file;

// service.found = found
export default service;
export const filePreviewUrl = fileUrl;
export { service, file, fileUrl };

export const post = (url, data, config = {}) => {
  return service.post(url, data, config);
};
export const get = (url, data) => {
  return service.get(url, {
    params: data
  });
};
export const getDownload = (url, data) => {
  return file.get(url, {
    params: data,
    responseType: "blob"
  });
};

function create(baseURL) {
  const instance = axios.create({
    baseURL,
    timeout
  });
  addInterceptor(instance);
  return instance;
}
function addInterceptor(service) {
  // request interceptor
  service.interceptors.request.use(
    config => {
      // do something before request is sent
      let datas = config.method === "post" ? config.data : config;
      if (datas.token) {
        config.headers["x-access-token"] = datas.token;
      }
      if (datas.projectId) {
        config.headers["project-id"] = datas.projectId;
      }
      config.headers["platform"] = datas.projectType;
      config.headers["application-type"] = "pc";
      return config;
    },
    error => {
      // do something with request error
      console.log(error); // for debug
      return Promise.reject(error);
    }
  );

  // response interceptor
  service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
      if (
        response.config.responseType === "blob" ||
        response.config.responseType === "arraybuffer" ||
        response.config.type === "noHold"
      ) {
        return response;
      }
      if (
        response.config.url.indexOf(".json") > -1 &&
        response.data instanceof Array
      ) {
        return response.data;
      }

      // if the custom code is not 20000, it is judged as an error.
      if (response.status === 200 && !response.data) {
        return errorHandler("status: 200 服务器没有返回任何响应");
      } else if (!response.data.success && response.data.code !== 200) {
        const message = response.data.message || response.data.msg || "Error";
        Message({
          message,
          type: "error",
          duration: 2 * 1000
        });
        return Promise.reject(new Error(message));
      } else {
        return response.data;
      }
    },
    error => {
      return errorHandler(
        "status: " + _.get(error, "response.status") + " " + error.message ||
          _.get(error, "response.data.message")
      );
    }
  );
}

/**
 * 弹出错误提示,生产环境只提示服务重启或者维护中，请稍后重试
 * @param message
 */
function errorHandler(message) {
  const isEnv = process.env.NODE_ENV === "development";
  Message({
    message: isEnv ? message : "服务重启或者维护中，请稍后重试",
    type: "error",
    duration: 2 * 1000
  });
  return Promise.reject(new Error(message));
}
